import apiUrls from 'apis/apiUrls';
import { axiosInstance } from 'helper/axiosHelper';

const checkupService = {
  getAllQsrCheckups: ({ page, ...params }: any) => {
    return axiosInstance.makeGetRequest({
      url: apiUrls.getAllQsrCheckups(),
      config: {
        params: {
          pageNumber: page || 1,
          ...params,
        },
      },
    });
  },

  downloadCheckupStatusExcel: (data: any) => {
    return axiosInstance.makePostRequest({
      url: apiUrls.downloadCheckupStatusExcel(),
      config: { responseType: 'blob' },
      data: {
        name: data.search || '',
        stores: data.stores,
        fitness: data.fitness || [],
        companyId: data.companyId,
        checkup_status: data.checkups || [],
      },
    });
  },

  updateCheckupStatus: (data: any) => {
    return axiosInstance.makePutRequest({
      url: apiUrls.updateCheckupStatus(),
      data,
    });
  },

  resendCheckupSMS: (params: { checkupId: string }) => {
    return axiosInstance.makePostRequest({
      url: apiUrls.resendCheckupSMS(),
      // data,
      config: { params },
    });
  },

  getFilteredCheckupStatus: ({ page, ...data }: any) => {
    return axiosInstance.makePostRequest({
      url: apiUrls.getFilteredCheckupStatus(),
      config: {
        params: { pageNumber: page || 1 },
      },
      data: {
        name: data.search || '',
        stores: data.stores,
        fitness: data.fitness || [],
        companyId: data.companyId,
        checkup_status: data.checkups || [],
      },
    });
  },
};

export default checkupService;
